const createProductsObj = (products) => {
  const productsObj = {}
  products.forEach(item => {
    productsObj[item.sku] = item
  })
  return productsObj
}

const getAttributeValue = (name, val, attributes) => {
  const numval = parseInt(val)
  if(isNaN(numval)){
    return val
  }
  const attributeValues = attributes.items.find(attr => attr.attribute_code === name)?.attribute_options
  if (attributeValues?.length > 0) {
    const attributeValueFormatted = attributeValues.find(value => (parseInt(value?.['value'])) === numval )
    if(attributeValueFormatted && attributeValueFormatted.label){
      return attributeValueFormatted.label
    }
  }
  return val
}

const getAttributeCodes = (attributes) => {
  return attributes.items.map(attribute => attribute.attribute_code)
}

const matchAttributeData = (products, attributes) => {
  const formattedProducts = products
  const attribute_codes = getAttributeCodes(attributes)
  Object.keys(products).forEach(sku => {
    const product = products[sku] || {}
    Object.keys(product).forEach(attr => {
      if (!!product[attr] && attribute_codes.includes(attr)) {
        formattedProducts[sku][attr] = getAttributeValue(attr, product[attr], attributes)
      }
    })
  })
  return formattedProducts
}

/*
 * @param rawProducts (from gql)
 * @param rawAttributes (from gql)
 * @returns productsWithAttributes
 */
const getMagentoProductsWithAttributes = (rawProducts, rawAttributes) => {
  return matchAttributeData(createProductsObj(rawProducts), rawAttributes)
}

/*
 * @param completeProducts (from gql/combined products/attributes)
 * @param skuString
 * @returns productsForTemplate
 */
const getProductsForTemplate = (completeProducts, skuString, template_name) => {
  const skus = skuString.split(",")
  const productsForTemplate = []
  skus.forEach((sku) => {
    if (completeProducts[sku]) {
      productsForTemplate.push(completeProducts[sku])
    } else {
      console.warn("sku data not found " + sku, template_name)
    }
  })
  return productsForTemplate
}

module.exports = { getMagentoProductsWithAttributes, getProductsForTemplate }